import { Component } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent {


  email: string = '';
  emailSent: boolean = false;

  constructor(private authService: AuthService){}

  async sendResetLink(){
    let emailRequest: boolean = await this.authService.passwordResetRequest(this.email)

    if(emailRequest){
      this.emailSent = true;
      this.authService.openSnackBar('Email has been sent!','');
      setTimeout(() =>{
        this.emailSent = false;
      }, 5000);
      return;
    }

    this.authService.openSnackBar('There was an issue sending out email', '');
  }
}
